module.exports = __webpack_public_path__ + "ring-half.png?e276e79460e15db5f2013c1481478991";